export const PART_TYPE_ANALYSIS_IDS = [43, 97];
export const NEW_YEAR_ANALYSIS_ID = 91;
export const ENGINE_BASE_ANALYSIS_ID = 210;
export const NEW_ENGINE_ANALYSIS_ID = 249;
export const NEW_TRANSMISSION_ANALYSIS_ID = 250;
export const SUB_CONFIG_ANALYSIS_ID = 209;
export const INVALID_PART_ATTRIBUTES_ANALYSIS_ID = 300;
export const INVALID_PART_ATTRIBUTE_VALUES_ANALYSIS_ID = 301;
